{
  "ep": {
    "errorSubcat": {
      "title": "Terjadi kesalahan",
      "desc": "Maaf, sepertinya terjadi kesalahan saat memuat halaman ini."
    },
    "popupDetail": {
      "label": "Harga Total"
    },
    "roaming": {
      "title": "Koneksi Aman di Luar Negeri",
      "subtitle": "Tetap terhubung di mana pun Anda berada",
      "label": "Kemana negara tujuanmu?",
      "textButton": "Cari Paket",
      "placeholder": "Cari negara tujuan",
      "checkpack": "Cari paket"
    },
    "unregistered": {
      "title": "Nomor ini tidak terdaftar",
      "description": "Maaf, nomor yang Anda masukan tidak terdaftar. Silahkan ulangi.",
      "buttonText": "Ya, Lanjutkan"
    },
    "form": {
      "titleText": "Nikmati penawaran paket terbaik hanya untukmu",
      "buttonLabel": "Cek",
      "simpatiLarge": "Masukkan nomor kamu untuk beli paket atau isi pulsa",
      "haloLarge": "Masukkan nomor kamu untuk bayar tagian atau beli paket"
    },
    "searchCounter": {
      "text": "Menampilkan",
      "result": "hasil",
      "for": "untuk"
    }
  },
  "simpati": {
    "popup": {
      "titleHeader": "Koneksi Lengkap Untuk Semua Aktivitas",
      "title": "Masukan Nomor SIMPATI",
      "description": "Cek paket yang tersedia atau langsung isi pulsa dengan mudah.",
      "placeholder": "Masukkan nomor SIMPATI",
      "buttonText": "Cek"
    },
    "downloadCenter": {
      "title": "Kelola Akun dan Dapatkan Promo Menarik Hanya di MyTelkomsel",
      "textButton": "Download MyTelkomsel"
    }
  },
  "halo": {
    "popup": {
      "titleHeader": "Buat Semua Kebutuhan Jadi Lebih Mudah",
      "title": "Masukan Nomor Halo",
      "description": "Cek paket yang tersedia atau langsung isi pulsa dengan mudah.",
      "placeholder": "Masukkan nomor HALO",
      "buttonText": "Cek"
    },
    "downloadCenter": {
      "title": "Kelola Akun dan Tagihan Halo, Lebih Mudah di MyTelkomsel",
      "textButton": "Download MyTelkomsel"
    },
    "otp": {
      "invalid": "Kode Otp Salah",
      "expired": "Kode otp kadaluarsa, silahkan kirim ulang otp",
      "maxAttempt": "Percobaan mencapai batas, silahkan kirim ulang otp",
      "general": "Terjadi kesalahan."
    },
    "bill": {
      "checkDescription": "Yuk cek detail info tagihan disini!",
      "checkNow": "Cek Sekarang",
      "dueDate": "Jatuh tempo"
    }
  },
  "dls": {
    "downloadCenter": {
      "title": "Jelajahi Hiburan Seru Hanya di MyTelkomsel",
      "textButton": "Download MyTelkomsel"
    },
    "popup": {
      "titleHeader": "Nikmati Beragam Aplikasi lebih hemat, lengkap, dan praktis",
      "title": "Masukan Nomor Telkomsel",
      "description": "Jelajahi penawaran paket nonton yang tersedia untukmu",
      "placeholder": "Masukkan nomor Telkomsel",
      "buttonText": "Cek"
    },
    "video": {
      "formTextLarge": "Masukkan Nomor dan Dapatkan Penawaran <span class='text-mustard'>Paket Nonton</span>",
      "formTextSmall": "Jelajahi Penawaran <span class='text-mustard'>Paket Nonton</span> Sesuai Kebutuhanmu"
    },
    "games": {
      "formTextLarge": "Masukkan Nomor dan Dapatkan Penawaran <span class='text-mustard'>Paket Games</span>",
      "formTextSmall": "Jelajahi Penawaran <span class='text-mustard'>Paket Games</span> Sesuai Kebutuhanmu"
    },
    "music": {
      "formTextLarge": "Masukkan Nomor dan Dapatkan Penawaran <span class='text-mustard'>Paket Musik & Digital</span>",
      "formTextSmall": "Jelajahi Penawaran <span class='text-mustard'>Paket Musik & Digital</span> Favoritmu"
    }
  },
  "digitalProduct": {
    "subscription": "Berlangganan",
    "title": "Masukkan nomor HP Anda untuk melihat pilihan dan harga paket khusus",
    "navbar": {
      "package": "Beli Paket",
      "phoneCredit": "Isi Pulsa",
      "billing": "Tagihan"
    },
    "button": {
      "findPackage": "Cari Paket",
      "findCredit": "Cari Pulsa",
      "viewAll": "Lihat Semua"
    },
    "stepper": {
      "orderConfirmation": "Konfirmasi Pesanan",
      "paymentMethod": "Metode Pembayaran",
      "orderStatus": "Status Pesanan",
      "activationStatus": "Jadwal Aktivasi"
    },
    "error": {
      "postpaidNotEligible": "Nomor tujuan tidak dapat diisi pulsa.",
      "emptyMsisdn": "Nomor tujuan tidak boleh kosong.",
      "unregistered": "Nomor tidak terdaftar atau salah, mohon cek kembali Nomor Anda.",
      "missLength": "Nomor tujuan tidak boleh lebih dari 13 dan kurang dari 9.",
      "badRequest": "Paket tidak tersedia untuk nomor yang dituju.",
      "other": "Terjadi kesalahan pada sistem. Silakan coba beberapa saat lagi.",
      "pageNonTsel": "Isi nomor terlebih dahulu untuk melihat pilihan dan harga paket"
    },
    "filter": {
      "serviceCardTitle": "Kartu Layanan",
      "destinationTitle": "Cari Destinasi",
      "packageTitle": "Filter Paket",
      "sortTitle": "Urutkan Paket",
      "priceTitle": "Harga",
      "quotaTitle": "Kuota",
      "packageType": "Jenis Paket {{name}}"
    },
    "input": {
      "destinationSearch": "Cari Negara"
    }
  },
  "placeholder": {
    "phone": "Masukkan nomor HP",
    "yourTelkomselNumber": "Masukkan Nomor Telkomsel Anda"
  },
  "input": {
    "msisdn": {
      "label": "Masukkan nomor HP",
      "example": "Contoh: ",
      "tselNumber": "Masukkan nomor Telkomsel"
    },
    "errors": {
      "requiredPhoneTsel": "Harap Masukkan Nomor Telkomsel Anda",
      "requiredPhoneTselOrOrbitNumber": "Harap Masukkan Nomor Telkomsel Prabayar atau Orbit Anda",
      "lessThanNineNumber": "Nomor kurang dari 9. Harap periksa kembali.",
      "required": "Nomor harus di isi.",
      "requiredText": "{{text}} harus di isi",
      "isNotMultipication": "Harus kelipatan 1000!",
      "minlengthText": "{{text}} kurang dari {{len}} digit, silakan masukkan kembali",
      "maxlengthText": "{{text}} melebihi batas maksimum {{len}} digit",
      "requiredNumberPhone": "*Wajib mengisi no.handphone",
      "requiredEmail": "*Wajib mengisi email",
      "notTselNumber": "Bukan nomor Telkomsel atau by.U. Harap periksa kembali.",
      "notTselNumber2": "Bukan nomor Telkomsel. Harap periksa kembali.",
      "notRegisteredNumber": "Nomor tidak terdaftar. Harap masukkan nomor Telkomsel",
      "internalServer": "Terjadi kesalahan silahkan coba kembali",
      "internalServer2": "Terjadi kesalahan silahkan coba lagi nanti",
      "email": "Email yang anda masukan tidak valid.",
      "notFound": "Data tidak ditemukan",
      "occurred": "Terjadi kesalahan saat memuat data",
      "customerNotFound": "Pelanggan tidak ditemukan",
      "requiredPhoneOrbit": "Harus menggunakan nomor Orbit Anda",
      "invalidTelkomselNumber": "Masukkan nomor Telkomsel yang sesuai (9-13 karakter)",
      "invalidHaloNumber": "Masukkan nomor Halo yang sesuai (9-13 karakter)",
      "invalidSimpatiNumber": "Masukkan nomor SIMPATI yang sesuai (9-13 karakter)",
      "countryNotFound": "Maaf, negara tidak tersedia"
    }
  },
  "errors": {
    "network": {
      "basic": "Terjadi kesahalan, coba lagi nanti."
    },
    "paymentNotAvailable": {
      "title": "Pilihan pembayaran dengan e-wallet tidak tersedia",
      "subtitle": "Silahkan tekan coba lagi untuk menampilkan metode pembayaran yang tersedia.",
      "cta": "Coba lagi"
    },
    "notfound": {
      "user": "Data pengguna tidak ditemukan",
      "invoice": {
        "dashboard": "Tidak ada invoice"
      },
      "package": "Paket tidak tersedia, Silahkan atur ulang Filter"
    },
    "internalError": {
      "reloadPage": "Silahkan Muat Ulang Halaman ini"
    },
    "login": {
      "invalid": {
        "credentials": "Terjadi Kesalahan, silahkan coba lagi"
      }
    }
  },
  "button": {
    "viewAll": "Lihat Semua",
    "loadMorePackages": "Muat Lebih Banyak Paket",
    "endOfListMessage": "Oops kamu telah mencapai akhir daftar paket.",
    "backToTop": "Kembali ke Atas",
    "resetFilter": "Reset Filter",
    "buy": "Beli",
    "accept": "Terima",
    "saveAsImage": "Simpan Kode Sebagai Gambar",
    "signIn": "Sign In",
    "submit": "Submit",
    "save": "Simpan",
    "edit": "Ubah",
    "connect": "Hubungkan",
    "back": "Kembali",
    "yes": "Iya",
    "yup": "Ya",
    "cancel": "Batal",
    "choose": "Pilih",
    "continue": "Lanjutkan",
    "pay": "Bayar",
    "sendOTP": "Kirim OTP",
    "change": "Ganti",
    "copy": "Salin",
    "package": "Paket",
    "detail": "Detail",
    "hide": "Sembunyikan",
    "exchange": "Tukar",
    "look": "Lihat",
    "apply": "Terapkan",
    "viewDetails": "Lihat Detail",
    "loadMore": "Muat lebih banyak",
    "loadMore2": "Muat Lebih",
    "reSend": "Kirim Ulang",
    "editLabel": "Edit Label",
    "toPayment": "Ke Pembayaran",
    "remove": "Hapus",
    "addNumber": "Tambah Nomor",
    "backToHome": "Kembali ke Beranda",
    "explore": "Mengeksplorasi Halo Digital Store",
    "backToExplore": "Kembali ke #JelajahDigital",
    "confirmPackageHallo": "Konfirmasi Paket Halo+",
    "tryAgain": "Coba Kembali",
    "deleteFilter": "Hapus Filter",
    "next": "Selanjutnya",
    "uploadImage": "Upload Gambar",
    "download": "Unduh",
    "resend": "Kirim Ulang",
    "close": "Tutup",
    "resubmit": "Submit Ulang",
    "delete": "Hapus",
    "buyPackage": "Beli Paket",
    "find": {
      "package": "Cari Paket",
      "bill": "Cari Tagihan",
      "credit": "Cari Pulsa"
    },
    "backtoapp": "Kembali ke Aplikasi",
    "deleteNo": "Tidak, Kembali",
    "deleteYes": "Ya, Hapus",
    "use": "Gunakan",
    "seeAll": "Lihat Semua",
    "play": "Mainkan",
    "manage": "Atur",
    "reset": "Atur Ulang",
    "done": "Selesai",
    "selectPayment": "Pilih Pembayaran",
    "skip": "Lewati",
    "viewBilling": "Lihat Tagihan",
    "seePackage5G": "Lihat Paket 5G",
    "rangeCheck": "Cek Jangkauan",
    "reload": "Muat Ulang",
    "saveAsDraft": "Simpan Draft",
    "applyToStore": "Terapkan",
    "existingNumber": "Gunakan nomor saat ini",
    "newNumber": "Dapatkan Nomor Baru",
    "proceedPayment": "Lanjutkan ke Pembayaran",
    "orderAccept": "Pesanan Diterima",
    "reload2": "Muat Ulang",
    "saveArchive": "Simpan & Arsipkan",
    "savePublish": "Simpan & Tampilkan",
    "verification": "Verifikasi",
    "buyNow": "Beli Sekarang",
    "toCheckout": "Ke Checkout",
    "sort": "Urutkan",
    "activated": "Aktifkan",
    "subscribe": "Berlangganan",
    "resetAlt": "Reset",
    "seeLocation": "Lihat Metode Pengiriman",
    "outOfStock": "Stok Belum Tersedia"
  },
  "label": {
    "packageOptions": "Pilihan Paket",
    "msisdnEmpty": "Paket belum tersedia silahkan masukkan nomor handphone anda!",
    "emptyPackageTitle": "Belum Ada Paket yang Sesuai",
    "emptyPackageDesc": "Paket belum tersedia, silakan lakukan penyesuaian ulang filter",
    "user": "Pengguna",
    "verified": "Verified",
    "change": "Ganti",
    "Laki-Laki": "Laki-Laki",
    "Perempuan": "Perempuan",
    "bill": "Tagihan",
    "credit": "Pulsa",
    "package": "Paket",
    "signIn": "Masuk",
    "logIn": "Masuk",
    "signOut": "Keluar",
    "endsIn": "Berakhir dalam",
    "promoHasEnded": "Promo Berakhir",
    "tnc": "Syarat dan Ketentuan Promo",
    "tnc2": "Syarat dan Ketentuan",
    "promoNotStarted": "Akan di mulai dalam",
    "validBilling": "Berlaku 1 Billing Cycle",
    "chooseProducts": "Pilih Produk",
    "categoryPackage": "Kategori Paket",
    "detailProduct": "Informasi Detail Produk",
    "price": "Harga",
    "activePeriod": "Masa Aktif",
    "lowest": "Terendah",
    "highest": "Tertinggi",
    "backSoon": "Kami akan segera kembali!",
    "notTelkomselNumber": "Bukan nomor Telkomsel. Harap periksa kembali",
    "backSoonDesc": "Mohon Maaf, layanan saat ini hanya tersedia dari pukul 06.00 - 20.00 WIB, karena keterbatasan validasi data kependudukan. Silakan coba lagi sesuai waktu tersebut.",
    "status": {
      "available": "Tersedia",
      "stillAvailable": "Masih Tersedia",
      "nearlyGone": "Hampir Habis",
      "finished": "Habis"
    },
    "notScheduleNotAvailable": "Jadwal Belum Tersedia",
    "team": "tim",
    "errorOccured": "Terjadi kesalahan server",
    "productDescription": "Deskripsi Produk",
    "seeDetails": "Lihat Selengkapnya",
    "saveWeb": "Telkomsel Halo App",
    "spesification": "Spesifikasi",
    "screen": "Layar",
    "rearCamera": "Kamera Belakang",
    "frontCamera": "Kamera Depan",
    "processor": "Prosesor",
    "baterai": "Baterai",
    "howToPay": "Cara Bayar",
    "orderSummary": "Ringkasan Pesanan",
    "totalPayment": "Total Pembayaran",
    "recommended": "Rekomendasi",
    "month": "bulan",
    "days": "hari",
    "hours": "jam",
    "minutes": "menit",
    "seconds": "detik",
    "promo5g": {
      "title": "Paket Hyper 5G",
      "checkNumber": "Cek Jangkauan 5G untuk Nomor Anda",
      "checkNumberSub": "Silakan masukkan nomor Telkomsel Anda, untuk mendapatkan paket 5G, lalu cek jangkauan 5G",
      "subtitle": "Rasakan pengalaman jaringan ultra cepat 5G dengan paket spesial, dapatkan di *363*56#.",
      "section": {
        "title": "Kenapa 5G?",
        "section1": {
          "title": "20x Lebih Cepat",
          "subtitle": "Koneksi data lebih cepat untuk download dan streaming yang lebih lancar."
        },
        "section2": {
          "title": "10x lebih responsif",
          "subtitle": "Latensi yang sangat rendah mampu membuat koneksi jadi lebih responsif."
        },
        "section3": {
          "title": "10x lebih besar",
          "subtitle": "Menghubungkan lebih banyak perangkat tanpa menurunkan kualitas jaringan."
        }
      }
    },
    "check5g": {
      "title": "Cek Jangkauan 5G",
      "subtitle": "Cek jangkauan 5G di lokasi Anda untuk menikmati paket 5G"
    },
    "noData": "Belum ada data",
    "fillNumberFirst": "Isi nomor terlebih dahulu untuk melihat tagihan",
    "transactionProcessed": "Transaksi Anda sedang diproses, silahkan tunggu atau tutup halaman ini",
    "detail": "Selengkapnya",
    "close": "Tutup",
    "failedToProcess": "Gagal Memproses",
    "shippingMethod": "Metode Pengiriman",
    "receiptNumber": "Nomor Resi",
    "orderStatus": "Status Pesanan",
    "seeEvidence": "Lihat Bukti Pengiriman",
    "allProducts": "Semua Produk",
    "active": "Aktif ({{len}})",
    "nonActive": "Non Aktif ({{len}})",
    "totalPrice": "Total Harga",
    "quota": "Kuota",
    "limited": "Terbatas",
    "OutOfStock": "Habis",
    "backToInformation": "Ke Informasi Pembeli",
    "description": "Deskripsi",
    "voucherDetails": "Detail Voucher",
    "minLengthTextarea": "Min. 20 Karakter",
    "sortLabel": "Urutkan",
    "emptyStock": "Stok Habis",
    "from": "Dari",
    "shareTitle": "Bagikan dengan yang lain",
    "seeMore": "Muat lebih",
    "share": "Bagikan",
    "stock": "Stok",
    "choose": "Pilih",
    "selected": "Terpilih",
    "available": "Tersedia",
    "alreadyUsed": "Sudah Terpakai",
    "cost": "Biaya",
    "period": "Periode",
    "call188": "Hubungi 188",
    "loading": "Sedang Mencari...",
    "name": "Nama",
    "filter": "Filter",
    "searchPlaceholder": "Ketik kata kunci pencarian kamu disini...",
    "searchHistory": "Riwayat Pencarian",
    "popularSearch": "Pencarian Populer",
    "packageRecommendation": "Rekomendasi Paket",
    "chooseLanguage": "Pilih Bahasa",
    "bahasaIndonesia": "Bahasa Indonesia",
    "voucherCode": "Kode Voucher",
    "voucher": "Voucher",
    "voucherCodeCopied": "Kode Voucher Tersalin!",
    "selectVariant": "Pilih Varian",
    "selectQuantity": "Pilih Jumlah",
    "useVoucher": "Gunakan Voucher",
    "allPackages": "Semua Paket",
    "productUnavailable": "Saat ini produk tidak tersedia",
    "productUnavailableDesc": "Jangan khawatir, produk akan tersedia lagi, cek kembali nanti ya!",
    "noMoreProducts": "Tidak ada produk lainnya.",
    "seeCreditOptions": "Lihat pilihan pulsa",
    "seePackageOptions": "Lihat pilihan paket",
    "loadLessCredit": "Muat pulsa lebih sedikit",
    "loadMoreCredit": "Muat pulsa lebih banyak",
    "priceValidation": "Harga maksimum harus lebih besar atau sama dengan harga minimum",
    "creditNominalOptions": "Pilihan Nominal Pulsa",
    "sold": "Terjual"
  },
  "transitionNumber": {
    "description": "Lanjut untuk melihat paket yang sesuai dengan nomor ini?",
    "registeredHalo": "Nomor ini terdaftar sebagai pelanggan Halo",
    "registeredOrbit": "Nomor ini terdaftar sebagai pelanggan Orbit",
    "registeredSimpati": "Nomor ini terdaftar sebagai pelanggan SIMPATI"
  },
  "billPopup": {
    "title": "Ada Tagihan yang Siap Dibayar",
    "description": "Yuk, cek detailnya dan lunasi tepat waktu biar layanan tetap aktif",
    "primaryButton": "Bayar Sekarang",
    "secondaryButton": "Nanti",
    "billInfo": {
      "status": "Belum Dibayar",
      "title": "Total Tagihan"
    }
  },
  "productDetail": {
    "tabs": {
      "detail": "Detail",
      "description": "Deskripsi",
      "tnc": "S&K"
    },
    "tabsAriaLabel": "Detail Produk",
    "closeAriaLabel": "Tutup",
    "detail": {
      "empty": "Tidak ada detail tersedia.",
      "dataDescription": "Kuota internet semua jaringan."
    },
    "description": {
      "title": "Deskripsi Paket"
    },
    "tnc": {
      "title": "Syarat & Ketentuan"
    },
    "footer": {
      "totalLabel": "Total Bayar",
      "currencySymbol": "Rp"
    }
  },
  "verification_otp": {
    "close": "Tutup",
    "title": "Verifikasi OTP",
    "description": "Masukkan kode rahasia yang telah dikirimkan melalui SMS ke",
    "retry": "Coba Lagi",
    "verify": "Verifikasi",
    "expires": "Berlaku hingga",
    "resend": "Kirim ulang kode OTP",
    "waiting": "Mohon menunggu untuk mengirim ulang OTP.",
    "errors": {
      "invalid": "Kode OTP Salah",
      "expired": "Kode OTP kadaluarsa, silakan kirim ulang OTP",
      "max_attempt": "Percobaan mencapai batas, silakan kirim ulang OTP",
      "general": "Terjadi kesalahan."
    }
  },
  "nobillPopup": {
    "title": "Belum Ada Tagihan",
    "description": "Tagihan kamu sudah lunas atau belum ada tagihan untuk nomor ini",
    "primaryButton": "Kembali"
  },
  "toast": {
    "general": "Percobaan masuk belum berhasil. Silakan coba kembali."
  }
}
